<ng-container [formGroup]="mainForm">
  <mbs-input *ngIf="params?.isOffline || params?.dataForPath?.isUnix"
             formControlName="destinationFolder"
             [attr.data-test-element]="elementsSelector.name.offlineOrUnix"
             [label]="hideLabel ? '' : destinationLabel"
             [name]="idPrefix + '-destinationFolder'"
             (input)="includeExcludeInputHandler($event)"
             [placeholder]="params?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"
             [id]="idPrefix + '-destination-folder-1'"
             [validationWhitespace]="true"
             (buttonClick)="destinationFolderTreeOpen()"
             [appendButtons]="[
               {
                 text: 'Browse',
                 id: idPrefix + '-destination-folder-tree-1',
                 disabled: mainForm.get('destinationFolder').disabled,
                 type: 'secondary'
               }
             ]"></mbs-input>

  <div *ngIf="!params?.isOffline && !params?.dataForPath?.isUnix"
       [attr.data-test-element]="elementsSelector.name.winAndOnline">
    <mbs-radio [name]="idPrefix + '-toFolder'"
               [(ngModel)]="toFolder"
               [ngModelOptions]="{ standalone: true }"
               (change)="toFolderChangeHandler()"
               [descriptionOutside]="false"
               [disabledSelf]="disabled"
               [label]="destinationLabel"
               [id]="idPrefix + '-to-folder'"
               [value]="true">
      <ng-template radioDescription>
        <mbs-input formControlName="destinationFolder"
                   [name]="idPrefix + '-destinationFolder'"
                   (input)="includeExcludeInputHandler($event)"
                   [placeholder]="'C:\\Folder Name'"
                   [id]="idPrefix + '-destination-folder-2'"
                   [validationWhitespace]="true"
                   (buttonClick)="destinationFolderTreeOpen()"
                   [appendButtons]="[
                     {
                       text: 'Browse',
                       id: idPrefix + '-destination-folder-tree-2',
                       disabled: mainForm.get('destinationFolder').disabled || !toFolder || disabled,
                       type: 'secondary'
                     }
                   ]"></mbs-input>
      </ng-template>
    </mbs-radio>
    <mbs-radio [name]="idPrefix + '-toFolder'"
               [(ngModel)]="toFolder"
               [ngModelOptions]="{ standalone: true }"
               (change)="toFolderChangeHandler()"
               [descriptionOutside]="false"
               [disabledSelf]="disabled"
               [label]="destinationNetworkLabel"
               [id]="idPrefix + '-to-shared'"
               [value]="false">
      <ng-template radioDescription>
        <mbs-input formControlName="destinationNetworkShare"
                   [name]="idPrefix + '-destinationNetworkShare'"
                   [placeholder]="'wizards:addNetworkSharePathPlaceholder' | i18next"
                   [id]="idPrefix + '-destination-network-share-4'"
                   [validationWhitespace]="true"></mbs-input>
        <!--<mbs-input formControlName="destinationNetworkShare"
                   [name]="idPrefix + '-destinationNetworkShare'"
                   [placeholder]="'wizards:addNetworkSharePathPlaceholder' | i18next"
                   [id]="idPrefix + '-destination-network-share-4'"
                   [validationWhitespace]="true"
                   (buttonClick)="addNetworkShare()"
                   [appendButtons]="[
                     {
                       text: 'Browse',
                       id: idPrefix + '-destination-network-share-tree-4',
                       disabled: mainForm.get('destinationNetworkShare').disabled || toFolder || !params?.canUseShareTree || disabled,
                       type: 'secondary'
                     }
                   ]"></mbs-input>-->
      </ng-template>
    </mbs-radio>
  </div>
</ng-container>
